import React, { useState, useEffect } from 'react'
import TreeDropdown from './Dropdown'
import { cloneDeep } from 'lodash'

/**
 * This function filters a tree based on its operations.
 * @param originalTree {interventionDataTypes[]} - a tree of drilling operations.
 * @param filterString {string} - a string to filter the tree by its operations types.
 * @returns {interventionDataTypes[]} - the tree filtered by its operations
 */

const treeFilterByDescription = (
    originalTree: Array<interventionDataTypes>,
    filterString: string
): Array<interventionDataTypes> => {
    let treeDataFiltered: Array<interventionDataTypes> = cloneDeep(originalTree)

    if (filterString !== '') {
        treeDataFiltered.forEach(intervention => {
            intervention.children.map(section => {
                section.children.map(run => {
                    run.children = run.children.filter(
                        operation =>
                            operation.label != undefined &&
                            operation.label.toLowerCase().includes(filterString.toLowerCase())
                    )
                })
                section.children = section.children.filter(run => run.children.length !== 0)
            })
            intervention.children = intervention.children.filter(section => section.children.length !== 0)
        })
        treeDataFiltered = treeDataFiltered.filter(e => e.children.length !== 0)
    }
    return treeDataFiltered
}

/**
 * This component filters the tree based on a text input
 * @param tree {TreeComponentProps} - data related to the tree (the items on the tree, an array of keys to all the items and the default expanded nodes)
 * @param select {TreeSelectingProps} - data related to the selection of the tree (the item selected, the function to change its selection, the timespan of the selected item and the run reference of the selected item)
 * @param check {TreeCheckingProps} - data related to the check items of the tree (data of the mainCheck, items checked, quantity of checkedOperations, and an option of using the individual timespans or the min and max of them)
 * @param selectFilter {selectFilterProps} - an object that contains the data related to a dropdown used to filter a tree by its operations.
 * @returns {JSX.Element} - a child that will return a JSX Element
 */

const TextFilter = ({
    select,
    check,
    tree,
    selectFilter
}: {
    tree: TreeFilteredComponentProps
    select: TreeSelectingProps
    check: TreeCheckingProps
    selectFilter: selectFilterProps
}) => {
    const [textFilter, setTextFilter] = useState('')
    const [filteredTree, setFilteredTree] = useState(tree.filteredTree)

    useEffect(() => {
        setFilteredTree(tree.filteredTree)
        setTextFilter('')
    }, [JSON.stringify(tree.filteredTree)])

    useEffect(() => {
        setFilteredTree(
            textFilter.length > 0 ? treeFilterByDescription(tree.filteredTree, textFilter) : tree.filteredTree
        )
    }, [textFilter])

    return (
        <TreeDropdown
            tree={{
                filteredTree: filteredTree,
                allKeys: tree.allKeys,
                defaultExpandedKeys: tree.defaultExpandedKeys,
                runTypesList: tree.runTypesList,
                formattedTree: tree.formattedTree
            }}
            select={select}
            selectFilter={selectFilter}
            check={check}
            textFilter={{
                setTextFilter: setTextFilter,
                textFilter: textFilter
            }}
        />
    )
}

export default TextFilter
